import { z } from 'zod';

const recipientOptions = [
  { value: 'me', label: 'Me' },
  { value: 'someone-else', label: 'Someone else' },
] as const;

const genderOptions = [
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
] as const;

const PatientSchema = z.object({
  recipient: z.enum(recipientOptions.map((option) => option.value)),
  firstName: z.string(),
  lastName: z.string(),
  dateOfBirth: z.string(),
  gender: z.enum(genderOptions.map((option) => option.value)),
});

type Patient = z.infer<typeof PatientSchema>;

export type { Patient };
export { recipientOptions, genderOptions };
